import { useMemo } from 'react';
import {
	ProgressBarWrapper,
	ProgressBarFill,
	ValueWrapper,
	Value,
} from './ProgressBar.style';

export type ProgressBarProps = {
	value: number;
	target: number;
	targettype?: string;
	inline?: boolean;
	useDynamicColors?: boolean;
	showPercent?: boolean;
	showValueLabel?: boolean;
};

export const ProgressBar = ({
	value,
	target,
	targettype,
	inline = true,
	useDynamicColors = false,
	showPercent = false,
	showValueLabel = false,
}: ProgressBarProps) => {
	const { progress, percent } = useMemo(() => {
		const safeTarget = target > 0 ? target : 1;
		const rawPercent = (value / safeTarget) * 100;

		return {
			progress: Math.min(Math.max(rawPercent / 100, 0), 1),
			percent: Math.round(rawPercent),
		};
	}, [value, target]);

	return (
		<ProgressBarWrapper $inline={inline}>
			<ProgressBarFill
				$progress={progress}
				$percent={percent}
				$useDynamicColors={useDynamicColors}
			/>

			{(showPercent || showValueLabel) ? (
				<ValueWrapper>
					{showPercent ? (
						<Value>{percent > 100 ? `🔥 ${percent}%` : `${percent}%`}</Value>
					) : (
						<span />
					)}

					{showValueLabel ? (
						<Value>
							{value} / {target} {targettype}
						</Value>
					) : null}
				</ValueWrapper>
			) : null}
		</ProgressBarWrapper>
	);
};
